var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
        callback: _vm.visibilityChanged,
        once: true,
        rootMargin: '-300px'
      }),expression:"{\n        callback: visibilityChanged,\n        once: true,\n        rootMargin: '-300px'\n      }"}],staticClass:"mt-5"},[_c('section',{staticClass:"bg-blue"},[_c('div',{staticClass:"container-lg"},[_c('h2',[_vm._v(_vm._s(_vm.$t('events_question')))]),_c('EventTable',{attrs:{"data":_vm.tableData}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }